import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import SavingsBanner from "@/components/landing/SavingsBanner";
import AppGallery from "@/components/landing/AppGallery";
import Manifesto from "@/components/landing/Manifesto";
import Benefits from "@/components/landing/Benefits";
import Journey from "@/components/landing/Journey";
import BrandMarquee from "@/components/landing/BrandMarquee";
import WaitlistSection from "@/components/landing/WaitlistSection";
import Footer from "@/components/landing/Footer";
import { captureTracking } from "@/lib/utm";

function App() {
  useEffect(() => {
    captureTracking();
  }, []);

  return (
    <SmoothScroll>
      <div className="App relative bg-[#1A1D24] text-[#F4F1ED]">
        <div className="grain-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <SavingsBanner />
          <Manifesto />
          <AppGallery />
          <Benefits />
          <Journey />
          <BrandMarquee />
          <WaitlistSection />
        </main>
        <Footer />
        <Toaster position="top-center" theme="dark" />
      </div>
    </SmoothScroll>
  );
}

export default App;
